import { lazy, Suspense } from "react";
import { ErrorBoundary } from "../components/ErrorBoundary";

const ManageTeam = lazy(
  () => import("../modules/upload-inbox/components/ManageTeam")
);

export function TeamPage() {
  return (
    <ErrorBoundary fallback={<div style={{ padding: 24 }}>Team Management failed to load.</div>}>
      <Suspense fallback={<div className="remote-loading"><p>Loading Team Management...</p></div>}>
        <ManageTeam />
      </Suspense>
    </ErrorBoundary>
  );
}
